import API from 'api';

export const getQuizTaken = async (input: {
  token: string;
  quizTakenId: string;
}): Promise<{ quiz: Types.API.QuizTaken.IQuizTakenInfoWithAnswers; remainingTime: number }> => {
  const response = await API.get('/parents/getQuizTaken', {
    headers: { Authorization: 'Bearer ' + input.token },
    params: { quizTakenId: input.quizTakenId },
  });
  return {
    quiz: response.data.quiz as Types.API.QuizTaken.IQuizTakenInfoWithAnswers,
    remainingTime: response.data.remainingTime,
  };
};

export const getAvailableQuizzes = async (input: {
  token: string;
  studentId: string;
}): Promise<{
  quizzes: Types.API.Quiz.IQuizInfo[];
  expiredQuizzes: Types.API.Quiz.IQuizInfo[];
  runningQuizzes: Types.API.QuizTaken.IQuizTakenInfo[];
  finishedQuizzes: Types.API.QuizTaken.IQuizTakenInfo[];
  gradePublishedQuizzes: Types.API.QuizTaken.IQuizTakenInfo[];
}> => {
  const response = await API.get('/parents/getAvailableQuizzes', {
    headers: { Authorization: 'Bearer ' + input.token },
    params: { studentId: input.studentId },
  });
  return {
    quizzes: response.data.quizzes,
    expiredQuizzes: response.data.expiredQuizzes,
    runningQuizzes: response.data.runningQuizzes,
    finishedQuizzes: response.data.finishedQuizzes,
    gradePublishedQuizzes: response.data.gradePublishedQuizzes,
  };
};
export const takeQuiz = async (input: {
  quizId: string;
  token: string;
}): Promise<Types.API.QuizTaken.IQuizTakenModel> => {
  const response = await API.post(
    '/students/takeQuiz',
    { quizId: input.quizId },
    { headers: { Authorization: 'Bearer ' + input.token }, params: { quizId: input.quizId } },
  );
  return response.data.quiz;
};
export const takeHomework = async (input: {
  quizId: string;
  token: string;
}): Promise<Types.API.QuizTaken.IQuizTakenModel> => {
  const response = await API.post(
    '/students/takeHomework',
    { quizId: input.quizId },
    { headers: { Authorization: 'Bearer ' + input.token }, params: { quizId: input.quizId } },
  );
  return response.data.homeworkTaken;
};

export const getAvailableHomeworks = async (input: {
  token: string;
  studentId: string;
}): Promise<{
  homeworks: Types.API.Quiz.IQuizInfo[];
  expiredHomeworks: Types.API.Quiz.IQuizInfo[];
  runningHomeworks: Types.API.QuizTaken.IQuizTakenInfo[];
  finishedHomeworks: Types.API.QuizTaken.IQuizTakenInfo[];
  gradePublishedHomeworks: Types.API.QuizTaken.IQuizTakenInfo[];
}> => {
  const response = await API.get('/parents/getAvailableHomeworks', {
    headers: { Authorization: 'Bearer ' + input.token },
    params: { studentId: input.studentId },
  });
  return {
    homeworks: response.data.homeworks,
    expiredHomeworks: response.data.expiredHomeworks,
    runningHomeworks: response.data.runningHomeworks,
    finishedHomeworks: response.data.finishedHomeworks,
    gradePublishedHomeworks: response.data.gradePublishedHomeworks,
  };
};
